'use client'

import { type ReactNode } from 'react'

import { Button, ButtonSize, ButtonVariant } from '@graftcode/design-system'
import * as Dialog from '@radix-ui/react-dialog'

import { preventDialogDismissForPickerInteraction } from './preventDialogDismissForPickerInteraction'

import styles from './FiltersMobileSheet.module.scss'

export type FiltersMobileSheetShellProps = {
  isOpen: boolean
  onClose: () => void
  title: string
  resetLabel: string
  applyLabel: string
  applyDisabled?: boolean
  onReset: () => void
  onApply: () => void
  children: ReactNode
}

export function FiltersMobileSheetShell({
  isOpen,
  onClose,
  title,
  resetLabel,
  applyLabel,
  applyDisabled = false,
  onReset,
  onApply,
  children,
}: FiltersMobileSheetShellProps) {
  return (
    <Dialog.Root modal={false} open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content
          className={styles.sheet}
          aria-describedby={undefined}
          onInteractOutside={preventDialogDismissForPickerInteraction}
          onPointerDownOutside={preventDialogDismissForPickerInteraction}
          onFocusOutside={preventDialogDismissForPickerInteraction}
        >
          <div className={styles.header}>
            <div className={styles.dragHandle} />
            <Dialog.Title className={styles.title}>{title}</Dialog.Title>
            <div className={styles.headerDivider} />
          </div>

          <div className={styles.content}>{children}</div>

          <div className={styles.footer}>
            <Button text={resetLabel} variant={ButtonVariant.Outlined} size={ButtonSize.L} onClick={onReset} />
            <Button
              text={applyLabel}
              variant={ButtonVariant.Primary}
              size={ButtonSize.L}
              disabled={applyDisabled}
              onClick={onApply}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
